import { IEntitiesState, initialEntitiesState } from './entities-state';
import { entitiesListReducer } from './entities-list-reducer';
import {
    EMPLOYEE_PAYSTUBS_RELATION_SET,
    EMPLOYEE_PAYSTUBS_MORE_RELATION_SET,
    EMPLOYEE_DOCUMENTS_RELATION_SET,
    EMPLOYEE_DOCUMENTS_MORE_RELATION_SET,
    EMPLOYEE_DEDUCTIONS_RELATION_SET,
    EMPLOYEE_DEDUCTIONS_MORE_RELATION_SET,
    EMPLOYEE_BENEFITS_RELATION_SET,
    EMPLOYEE_BENEFITS_MORE_RELATION_SET,
    CONTRACTOR_PAYMENTS_RELATION_SET,
    CONTRACTOR_PAYMENTS_MORE_RELATION_SET,
    CONTRACTOR_DOCUMENTS_RELATION_SET,
    CONTRACTOR_DOCUMENTS_MORE_RELATION_SET,
    EMPLOYEE_WAGES_RELATION_SET
} from '@core/state/action-types';

export function reducer(state = initialEntitiesState(), action: any): IEntitiesState {

    switch (action.type) {
        
        case EMPLOYEE_PAYSTUBS_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeePaystubs: {
                        ...state.relationships.employeePaystubs,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };

        case EMPLOYEE_PAYSTUBS_MORE_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeePaystubs: {
                        ...state.relationships.employeePaystubs,
                        [action.payload.relatedId]: [...state.relationships.employeePaystubs[action.payload.relatedId], ... action.payload.itemIds]
                    }
                }
            };

        case EMPLOYEE_DOCUMENTS_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeeDocuments: {
                        ...state.relationships.employeeDocuments,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };

        case EMPLOYEE_DOCUMENTS_MORE_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeeDocuments: {
                        ...state.relationships.employeeDocuments,
                        [action.payload.relatedId]: [...state.relationships.employeeDocuments[action.payload.relatedId], ... action.payload.itemIds]
                    }
                }
            };

        case EMPLOYEE_DEDUCTIONS_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeeDeductions: {
                        ...state.relationships.employeeDeductions,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };  

        case EMPLOYEE_DEDUCTIONS_MORE_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeeDeductions: {
                        ...state.relationships.employeeDeductions,
                        [action.payload.relatedId]: [...state.relationships.employeeDeductions[action.payload.relatedId], ... action.payload.itemIds]
                    }
                }
            };

        case EMPLOYEE_BENEFITS_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeeBenefits: {
                        ...state.relationships.employeeBenefits,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };

        case EMPLOYEE_BENEFITS_MORE_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeeBenefits: {
                        ...state.relationships.employeeBenefits,
                        [action.payload.relatedId]: [...state.relationships.employeeBenefits[action.payload.relatedId], ... action.payload.itemIds]
                    }
                }
            };

        case EMPLOYEE_WAGES_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    employeeWages: {
                        ...state.relationships.employeeWages,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };

        case CONTRACTOR_PAYMENTS_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    contractorPayments: {
                        ...state.relationships.contractorPayments,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };

        case CONTRACTOR_PAYMENTS_MORE_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    contractorPayments: {
                        ...state.relationships.contractorPayments,
                        [action.payload.relatedId]: [...state.relationships.contractorPayments[action.payload.relatedId], ... action.payload.itemIds]
                    }
                }
            };

        case CONTRACTOR_DOCUMENTS_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    contractorDocuments: {
                        ...state.relationships.contractorDocuments,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };

        case CONTRACTOR_DOCUMENTS_MORE_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    contractorDocuments: {
                        ...state.relationships.contractorDocuments,
                        [action.payload.relatedId]: [...state.relationships.contractorDocuments[action.payload.relatedId], ... action.payload.itemIds]
                    }
                }
            };

        default:
            let nextState: IEntitiesState = state;
            if (action.payload && action.payload.domain) {
                const { domain } = action.payload;
                nextState = {
                    ...state,
                    entities: {
                        ...state.entities,
                        [domain]: entitiesListReducer(state.entities[domain], action)
                    }

                };
            }

            return nextState;
    }
}
